'use strict';

var React = require('react');

var SvgHintMajor = function SvgHintMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M10 0a1 1 0 0 1 1 1v1a1 1 0 1 1-2 0v-1a1 1 0 0 1 1-1zm2 17v1.5a1.5 1.5 0 0 1-1.5 1.5h-1a1.5 1.5 0 0 1-1.5-1.5v-1.5h4zm6-8a1 1 0 1 0 0 2h1a1 1 0 1 0 0-2h-1zm-18 1a1 1 0 0 1 1-1h1a1 1 0 1 1 0 2h-1a1 1 0 0 1-1-1zm4.343-7.071a1 1 0 0 0-1.413 1.414l.707.707a1 1 0 1 0 1.413-1.414l-.707-.707zm10.607 2.121a1 1 0 0 1 0-1.414l.707-.707a1 1 0 1 1 1.414 1.414l-.707.707a1 1 0 0 1-1.414 0zm-1.682 6.257c-.618.874-1.268 1.817-1.268 2.888v.805h-4v-.805c0-1.07-.65-2.014-1.268-2.888a4 4 0 1 1 6.536 0z"
  }));
};

exports.SvgHintMajor = SvgHintMajor;
